export const FONT_FAMILY = 'Inter, sans-serif'
export const THEME_COLOR = {
    AcentColor:'#FD513B',
    NavyDark:'#263238',
    PrimaryDark:'#0A1746',
    GreyDarkest:'#445058'
    
}